import React from "react";
import { useSelector } from "react-redux";
import { isValidUrl } from "../../../utils/utils";
import TextInput from "../textInput/TextInput";

const UrlInput = ({ value, onChange, label, placeholder }) => {
    const { texts } = useSelector((state) => state.translate);
    const showError = value.trim() && !isValidUrl(value);

    return (
        <TextInput
            label={label}
            value={value}
            onChange={onChange}
            placeholder={placeholder ?? "https://example.com"}
            error={showError ? texts.invalidLinkFormat : undefined}
        />
    );
};

export default UrlInput;
